module.exports = __webpack_public_path__ + "img/nepal.6c51916f.svg";